import React from "react";

type Props = React.ComponentPropsWithoutRef<"dialog"> & { trailing?: React.ReactNode; popover?: "manual" };

/** Shares the navigator action-strip structure and isolates menu actions from row selection. */
export default function TreeMenuPanel({ children, trailing, className = "", ...props }: Props) {
  return <dialog {...props} className={`treeMenuButtons ${className}`}
    onDoubleClick={event => { event.stopPropagation(); event.preventDefault(); }}
    onClick={event => {
      event.stopPropagation();
      if (!(event.target instanceof Element) || !event.target.closest("input, label, button")) event.preventDefault();
    }}>
    <div className="treeMenuButtonsInner">{children}</div>
    {trailing}
  </dialog>;
}
